import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
};

export const contentReducer = createReducer(initialState, (builder) => {
  // Category
  builder
    .addCase("GET_ALL_CATEGORIES_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_CATEGORIES_SUCCESS", (state, action) => {
      state.loading = false;
      state.categoriesList = action.payload.categoriesList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_CATEGORIES_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Carousel
  builder
    .addCase("GET_ALL_CAROUSELS_IMAGES_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_CAROUSELS_IMAGES_SUCCESS", (state, action) => {
      state.loading = false;
      state.carouselsList = action.payload.carouselsList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_CAROUSELS_IMAGES_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Team
  builder
    .addCase("GET_ALL_TEAMS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_TEAMS_SUCCESS", (state, action) => {
      state.loading = false;
      state.teamsList = action.payload.teamsList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_TEAMS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Testimonial
  builder
    .addCase("GET_ALL_TESTIMONIALS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_TESTIMONIALS_SUCCESS", (state, action) => {
      state.loading = false;
      state.testimonialsList = action.payload.testimonialsList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_TESTIMONIALS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Mission & Vision
  builder
    .addCase("GET_ALL_MISSION_AND_VISION_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_MISSION_AND_VISION_SUCCESS", (state, action) => {
      state.loading = false;
      state.missionAndVisionsList = action.payload.missionAndVisionsList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_MISSION_AND_VISION_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Events
  builder
    .addCase("GET_ALL_EVENTS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_EVENTS_SUCCESS", (state, action) => {
      state.loading = false;
      state.eventsList = action.payload.eventsList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_EVENTS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Our Story
  builder
    .addCase("GET_ALL_OUR_STORY_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_OUR_STORY_SUCCESS", (state, action) => {
      state.loading = false;
      state.ourStoriesList = action.payload.ourStoriesList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_OUR_STORY_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Gallery
  builder
    .addCase("GET_ALL_GALLERY_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_GALLERY_SUCCESS", (state, action) => {
      state.loading = false;
      state.galleryList = action.payload.galleryList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_GALLERY_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Booking Requests
  builder
    .addCase("GET_ALL_BOOKINGS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_BOOKINGS_SUCCESS", (state, action) => {
      state.loading = false;
      state.bookingRequestsList = action.payload.bookingRequestsList;
      state.bookingRequestsCount = action.payload.count;
    })
    .addCase("GET_ALL_BOOKINGS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });

  // Users List
  builder
    .addCase("GET_ALL_USERS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_USERS_SUCCESS", (state, action) => {
      state.loading = false;
      state.usersList = action.payload.usersList;
      state.usersCount = action.payload.count;
    })
    .addCase("GET_ALL_USERS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });
});
